export default __webpack_public_path__ + "static/media/Energy.a0091167.jpg";